<template>
  <v-col cols="12" class="oee-nyx">
    <div class="oee-nyx__filters">
      <v-row>
        <v-col cols="3">
          <v-select v-model="selectedYear" :items="years" item-text="label" item-value="value" label="Año"
            :loading="loading" :disabled="loading" @change="onYearChange" />
        </v-col>
        <v-col cols="3">
          <v-select v-model="selectedWeek" :items="weeks" item-text="label" item-value="value" label="Semana del año"
            :loading="loading" :disabled="loading" @change="onWeekChange" />
        </v-col>
        <v-col cols="3">
          <v-autocomplete v-model="instanciasSel" :items="instancias" :item-text="nombreMaquina"
            item-value="idMaquinaIns" multiple label="Máquinas" chips :loading="loading" :disabled="loading"
            clearable />
        </v-col>
        <v-col cols="3">
          <v-autocomplete v-model="turnosSel" :items="turnos" item-text="nombre" item-value="idTurno" multiple
            label="Turnos" chips :loading="loading" :disabled="loading" clearable />
        </v-col>
        <!-- <v-col cols="3">
          <v-text-field v-model="selectedWeekRange" label="Rango" readonly />
        </v-col> -->
        <v-col cols="3" class="d-flex align-center">
          <v-btn color="primary" :loading="loading" :disabled="loading || !selectedWeekInfo" @click="obtenerDatos">
            Consultar
          </v-btn>
          <v-btn
            text
            color="primary"
            class="ml-2"
            :loading="loading"
            :disabled="loading || !selectedWeekInfo"
            @click="descargarExcel"
          >
            Descargar Excel
          </v-btn>
        </v-col>
      </v-row>
    </div>

    <LoaderData :loading="loading" :response="loaderResponse">
      <v-tabs v-model="activeTab" class="oee-nyx__tabs" show-arrows>
        <v-tab v-for="tab in tabs" :key="tab.key">
          {{ tab.label }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="activeTab">
        <v-tab-item v-for="tab in tabs" :key="tab.key">
          <div v-if="tab.groups.length" class="oee-nyx__table-wrapper">
            <table class="oee-nyx__table">
              <tbody v-for="(group, groupIndex) in tab.groups" :key="group.key">
                <tr class="oee-nyx__header-row">
                  <th v-for="(col, colIndex) in columns" :key="col.key" :class="headerCellClass(col)">
                    {{ colIndex === 0 ? group.shiftLabel : col.label }}
                  </th>
                </tr>

                <tr v-for="(row, rowIndex) in group.rows"
                  :key="row.idArticulo || row.id || `${group.turno}-${rowIndex}`">
                  <template v-for="col in columns">
                    <td v-if="col.key !== 'maquina' || row.__machineRowspan !== 0" :key="col.key"
                      :rowspan="col.key === 'maquina' ? (row.__machineRowspan || 1) : null" :class="cellClass(col)">
                      <span :class="valueClass(formatCell(row, col))">
                        {{ formatCell(row, col) }}
                      </span>
                    </td>
                  </template>
                </tr>

                <tr class="oee-nyx__summary-row">
                  <td v-for="col in columns" :key="col.key" :class="cellClass(col)">
                    <span :class="valueClass(formatCell(group.summary, col))">
                      {{ formatCell(group.summary, col) }}
                    </span>
                  </td>
                </tr>

                <tr v-if="groupIndex < tab.groups.length - 1" class="oee-nyx__spacer">
                  <td :colspan="columns.length"></td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else class="oee-nyx__empty">No data</div>
        </v-tab-item>
      </v-tabs-items>
    </LoaderData>
  </v-col>
</template>

<script>
import LoaderData from '../../../LoaderData.vue';
import axios from 'axios';

const sampleData = [
];

export default {
  components: {
    LoaderData,
  },
  data() {
    return {
      items: [],
      weekItems: [],
      instanciasSel: [],
      turnosSel: [],
      instancias: [],
      turnos: [],
      activeTab: 0,
      years: [],
      selectedYear: null,
      weeks: [],
      selectedWeek: null,
      columns: [
        { key: "maquina", label: "Máquina", align: "center", type: "text" },
        { key: "articulo", label: "Artículo", align: "center", type: "text" },
        { key: "piezasOk", label: "Total piezas ok", align: "center", type: "number", decimals: 0 },
        { key: "scrap", label: "Total piezas no ok", align: "center", type: "number", decimals: 0 },
        { key: "totalPiezas", label: "Piezas totales", align: "right", type: "number", decimals: 0, shaded: true },
        {
          key: "tiempoOperacionSeg",
          label: "Horas totales activas",
          align: "right",
          type: "hours",
          fromSeconds: true,
          shaded: true
        },
        {
          key: "segundosDebieronTrabajar",
          label: "horas planeadas de producción",
          align: "right",
          type: "hours",
          fromSeconds: true,
          shaded: true
        },
        {
          key: "tiempoParoNoProgramadoSeg",
          label: "Horas de paro",
          align: "right",
          type: "hours",
          fromSeconds: true,
          shaded: true
        },
        {
          key: "piezasXHoraTeoricas",
          label: "Piezas por hora",
          align: "right",
          type: "number",
          decimals: 2,
          shaded: true,
          aggregate: "avg"
        },
        {
          key: "piezasXHoraReport",
          label: "Piezas por hora reales",
          align: "right",
          type: "number",
          decimals: 2,
          shaded: true,
          aggregate: "avg"
        },
        {
          key: "disponibilidad",
          label: "Disponibilidad",
          align: "right",
          type: "percent",
          decimals: 2,
          shaded: true,
          aggregate: "avg"
        },
        {
          key: "eficiencia",
          label: "Eficiencia",
          align: "right",
          type: "percent",
          decimals: 2,
          shaded: true,
          aggregate: "avg"
        },
        {
          key: "calidad",
          label: "Calidad",
          align: "right",
          type: "percent",
          decimals: 2,
          shaded: true,
          aggregate: "avg"
        },
        {
          key: "oee",
          label: "OEE",
          align: "right",
          type: "percent",
          decimals: 2,
          shaded: true,
          aggregate: "avg"
        }
      ],
      loading: false,
      loadingInstancias: false,
      loadingTurno: false,
    };
  },
  computed: {
    itemsToRender() {
      return this.items && this.items.length ? this.items : sampleData;
    },
    weekItemsToRender() {
      return this.weekItems && this.weekItems.length ? this.weekItems : [];
    },
    detailRows() {
      return this.flattenItems(this.itemsToRender);
    },
    weekRows() {
      return this.flattenItems(this.weekItemsToRender);
    },
    dayTabs() {
      const groups = new Map();
      this.detailRows.forEach((row, index) => {
        const label = this.getDayLabel(row);
        const key = this.getDayKey(row, label, index);
        if (!groups.has(key)) {
          groups.set(key, { key, label, rows: [], sortKey: "" });
        }
        groups.get(key).rows.push(row);
      });

      const ordered = Array.from(groups.values()).map((group) => {
        const dates = group.rows
          .map((row) => this.getSortableDate(row))
          .filter(Boolean)
          .sort();
        return {
          ...group,
          sortKey: dates.length ? dates[0] : ""
        };
      });
      ordered.sort((a, b) => {
        if (a.sortKey && b.sortKey) return String(a.sortKey).localeCompare(String(b.sortKey));
        if (a.sortKey) return -1;
        if (b.sortKey) return 1;
        const orderA = this.dayOrder(a.label);
        const orderB = this.dayOrder(b.label);
        if (orderA !== orderB) return orderA - orderB;
        return String(a.key).localeCompare(String(b.key));
      });
      return ordered;
    },
    tabs() {
      const tabs = this.dayTabs.map((tab) => ({
        ...tab,
        groups: this.buildGroupedByShift(tab.rows),
      }));
      const weekRows = this.weekRows.length ? this.weekRows : this.detailRows;
      tabs.push({
        key: "SEMANA",
        label: "Semana",
        rows: weekRows,
        groups: this.buildGroupedByShift(weekRows),
      });
      return tabs;
    },
    loaderResponse() {
      if (this.items && this.items.length) return this.items;
      if (this.weekItems && this.weekItems.length) return this.weekItems;
      return [];
    },
    selectedWeekInfo() {
      return this.weeks.find((week) => week.value === this.selectedWeek) || null;
    },
    selectedWeekRange() {
      if (!this.selectedWeekInfo) return "";
      return `${this.formatDMY(this.selectedWeekInfo.desde)} - ${this.formatDMY(this.selectedWeekInfo.hasta)}`;
    }
  },
  methods: {
    nombreMaquina: (maquina) => `[${maquina.nombre}] - ${maquina.marca} ${maquina.modelo}`,

    init() {
      this.getInstancias();
      this.getTurnos();
    },
    getInstancias() {
      this.loadingInstancias = true;
      axios
        .get('/MaquinaInstancias')
        .then(res => (this.instancias = res.data))
        .catch(err => console.log(err))
        .finally(() => {
          this.loadingInstancias = false;
        });
    },
    getTurnos() {
      this.loadingTurno = true;
      axios
        .get('/Turnos')
        .then(res => (this.turnos = res.data))
        .catch(err => console.log(err))
        .finally(() => {
          this.loadingTurno = false;
        });
    },
    onYearChange() {
      this.refreshWeeksForYear(this.selectedYear, true);
      this.activeTab = 0;
      this.obtenerDatos();
    },
    onWeekChange() {
      this.activeTab = 0;
      this.obtenerDatos();
    },
    initYears() {
      const now = new Date();
      const currentYear = now.getFullYear();
      const startYear = currentYear - 3;
      const endYear = currentYear + 1;
      const years = [];
      for (let year = startYear; year <= endYear; year += 1) {
        years.push({ value: year, label: String(year) });
      }
      this.years = years;
      this.selectedYear = currentYear;
      this.refreshWeeksForYear(currentYear, true);
    },
    refreshWeeksForYear(yearValue, preferCurrentWeek = false) {
      const year = Number(yearValue);
      if (!Number.isFinite(year)) {
        this.weeks = [];
        this.selectedWeek = null;
        return;
      }
      this.weeks = this.buildWeeksForYear(year);
      if (!this.weeks.length) {
        this.selectedWeek = null;
        return;
      }
      if (preferCurrentWeek) {
        const iso = this.getIsoWeek(new Date());
        if (iso && iso.year === year) {
          const weekStr = String(iso.week).padStart(2, "0");
          const candidate = `${year}-W${weekStr}`;
          if (this.weeks.some((week) => week.value === candidate)) {
            this.selectedWeek = candidate;
            return;
          }
        }
      }
      this.selectedWeek = this.weeks[0].value;
    },
    buildWeeksForYear(year) {
      const totalWeeks = this.weeksInYear(year);
      const weeks = [];
      for (let week = 1; week <= totalWeeks; week += 1) {
        const start = this.isoWeekStart(year, week);
        const end = new Date(start);
        end.setUTCDate(start.getUTCDate() + 6);
        const desde = this.formatYMD(start);
        const hasta = this.formatYMD(end);
        const weekStr = String(week).padStart(2, "0");
        weeks.push({
          value: `${year}-W${weekStr}`,
          label: `Semana ${weekStr} (${this.formatDMY(desde)} - ${this.formatDMY(hasta)})`,
          desde,
          hasta,
        });
      }
      return weeks;
    },
    weeksInYear(year) {
      const dec28 = new Date(Date.UTC(year, 11, 28));
      const iso = this.getIsoWeek(dec28);
      return iso ? iso.week : 52;
    },
    getIsoWeek(dateObj) {
      if (!(dateObj instanceof Date) || Number.isNaN(dateObj.getTime())) return null;
      const d = new Date(Date.UTC(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate()));
      const dayNum = d.getUTCDay() || 7;
      d.setUTCDate(d.getUTCDate() + 4 - dayNum);
      const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
      const week = Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
      return { year: d.getUTCFullYear(), week };
    },
    isoWeekStart(year, week) {
      const simple = new Date(Date.UTC(year, 0, 1 + (week - 1) * 7));
      const dow = simple.getUTCDay();
      const diff = dow <= 4 ? 1 - dow : 8 - dow;
      simple.setUTCDate(simple.getUTCDate() + diff);
      return simple;
    },
    formatYMD(dateObj) {
      if (!(dateObj instanceof Date) || Number.isNaN(dateObj.getTime())) return "";
      return dateObj.toISOString().slice(0, 10);
    },
    formatDMY(value) {
      const raw = String(value || "").trim();
      if (!/^\d{4}-\d{2}-\d{2}$/.test(raw)) return raw;
      const [yyyy, mm, dd] = raw.split("-");
      return `${dd}/${mm}/${yyyy}`;
    },
    normalizeIndividualItems(items) {
      const source = Array.isArray(items) ? items : [];
      if (!source.length) return [];

      const groups = new Map();
      source.forEach((row, index) => {
        const key = this.getDailyGroupKey(row, index);
        if (!groups.has(key)) {
          groups.set(key, {
            shiftRows: [],
            dayRows: [],
            dayIndices: new Set(),
            lastShiftIndex: -1
          });
        }

        const group = groups.get(key);
        if (this.isDaySummaryRow(row)) {
          group.dayRows.push(row);
          group.dayIndices.add(index);
          return;
        }

        group.shiftRows.push(row);
        group.lastShiftIndex = index;
      });

      const insertions = new Map();
      groups.forEach((group) => {
        if (group.lastShiftIndex < 0) return;

        let extras = group.dayRows;
        if (!extras.length) {
          const generated = this.buildDailySummaryFromShiftRows(group.shiftRows);
          extras = generated ? [generated] : [];
        }

        if (!extras.length) return;
        const current = insertions.get(group.lastShiftIndex) || [];
        insertions.set(group.lastShiftIndex, current.concat(extras));
      });

      const normalized = [];
      source.forEach((row, index) => {
        const key = this.getDailyGroupKey(row, index);
        const group = groups.get(key);
        const skipOriginalDayRow = Boolean(
          group &&
          group.lastShiftIndex >= 0 &&
          group.dayIndices.has(index)
        );

        if (!skipOriginalDayRow) {
          normalized.push(row);
        }

        const extras = insertions.get(index);
        if (extras?.length) {
          extras.forEach((extra) => normalized.push(extra));
        }
      });

      return normalized;
    },
    getDailyGroupKey(row, index) {
      const machine = row?.maquinaIns ?? row?.MaquinaIns ?? row?.maquina ?? row?.Maquina ?? "";
      const fecha = this.normalizeDateString(
        row?.fecha ?? row?.Fecha ?? row?.inicio ?? row?.Inicio ?? ""
      );
      if (!machine && !fecha) return `IDX-${index}`;
      return `${machine || "SIN_MAQUINA"}|${fecha || "SIN_FECHA"}`;
    },
    isDaySummaryTurno(turno) {
      const normalized = String(turno || "")
        .trim()
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
      return normalized === "dia" || normalized === "day";
    },
    isDaySummaryRow(row) {
      return this.isDaySummaryTurno(row?.turno ?? row?.Turno);
    },
    sumFromRows(rows, getValue) {
      let hasValue = false;
      let total = 0;
      (rows || []).forEach((row) => {
        const num = this.toNumber(getValue(row));
        if (num == null) return;
        hasValue = true;
        total += num;
      });
      return hasValue ? total : null;
    },
    avgFromRows(rows, getValue) {
      let total = 0;
      let count = 0;
      (rows || []).forEach((row) => {
        const num = this.toNumber(getValue(row));
        if (num == null) return;
        total += num;
        count += 1;
      });
      return count ? total / count : null;
    },
    weightedAvgFromRows(rows, getValue, getWeight) {
      let weightedTotal = 0;
      let weightTotal = 0;
      (rows || []).forEach((row) => {
        const value = this.toNumber(getValue(row));
        const weight = this.toNumber(getWeight(row));
        if (value == null || weight == null || weight <= 0) return;
        weightedTotal += value * weight;
        weightTotal += weight;
      });
      if (weightTotal > 0) return weightedTotal / weightTotal;
      return this.avgFromRows(rows, getValue);
    },
    minDateTime(values) {
      const valid = (values || [])
        .map((value) => String(value || "").trim())
        .filter(Boolean)
        .sort();
      return valid.length ? valid[0] : null;
    },
    maxDateTime(values) {
      const valid = (values || [])
        .map((value) => String(value || "").trim())
        .filter(Boolean)
        .sort();
      return valid.length ? valid[valid.length - 1] : null;
    },
    buildDailySummaryFromShiftRows(rows) {
      const source = Array.isArray(rows) ? rows.filter((row) => !this.isDaySummaryRow(row)) : [];
      if (!source.length) return null;

      const first = source[0];
      const pick = (row, keys) => {
        for (let index = 0; index < keys.length; index += 1) {
          const key = keys[index];
          if (row?.[key] != null) return row[key];
        }
        return null;
      };

      const totalPiezas = this.sumFromRows(source, (row) => pick(row, ["totalPiezas", "TotalPiezas"]));
      const piezasOk = this.sumFromRows(source, (row) => pick(row, ["piezasOk", "PiezasOk"]));
      const piezasNoOk = this.sumFromRows(source, (row) => this.getPiezasNoOk(row));
      const tiempoOperacionSeg = this.sumFromRows(source, (row) =>
        pick(row, ["tiempoOperacionSeg", "TiempoOperacionSeg", "activoNyxSeg", "ActivoNyxSeg"])
      );
      const segundosDebieronTrabajar = this.sumFromRows(source, (row) =>
        pick(row, ["segundosDebieronTrabajar", "SegundosDebieronTrabajar"])
      );
      const tiempoParoNoProgramadoSeg = this.sumFromRows(source, (row) =>
        pick(row, ["tiempoParoNoProgramadoSeg", "TiempoParoNoProgramadoSeg", "tiempoParosSeg", "TiempoParosSeg"])
      );
      const piezasXHoraTeoricas = this.avgFromRows(source, (row) =>
        pick(row, ["piezasEsperadasHoraNYX", "PiezasEsperadasHoraNYX", "piezasXHoraTeoricas", "PiezasXHoraTeoricas"])
      );
      const disponibilidad = this.avgFromRows(source, (row) =>
        pick(row, ["disponibilidadNyx", "DisponibilidadNyx", "disponibilidad", "Disponibilidad"])
      );
      const eficiencia = this.avgFromRows(source, (row) =>
        pick(row, ["eficiencia", "Eficiencia", "eficienciaNyx", "EficienciaNyx"])
      );
      const oee = this.avgFromRows(source, (row) => pick(row, ["oee", "Oee"]));
      const calidad =
        totalPiezas != null && totalPiezas > 0 && piezasOk != null
          ? (piezasOk / totalPiezas) * 100
          : this.avgFromRows(source, (row) => pick(row, ["calidad", "Calidad"]));
      const piezasXHoraReport =
        totalPiezas != null && tiempoOperacionSeg != null && tiempoOperacionSeg > 0
          ? totalPiezas / (tiempoOperacionSeg / 3600)
          : this.avgFromRows(source, (row) => pick(row, ["piezasXHoraReport", "PiezasXHoraReport"]));
      const tiempoCiclo = this.weightedAvgFromRows(
        source,
        (row) => pick(row, ["tiempoCiclo", "TiempoCiclo"]),
        (row) => pick(row, ["operacionesCant", "OperacionesCant", "totalPiezas", "TotalPiezas"])
      );

      const detallessParos = source.flatMap((row) => {
        const raw =
          row?.detallessParos ??
          row?.DetallessParos ??
          row?.detallesParos ??
          row?.DetallesParos;
        return Array.isArray(raw) ? raw : [];
      });

      const inicio = this.minDateTime(source.map((row) => pick(row, ["inicio", "Inicio"]))) || first.inicio || null;
      const fin = this.maxDateTime(source.map((row) => pick(row, ["fin", "Fin"]))) || first.fin || null;
      const tiempoBruto = this.sumFromRows(source, (row) => pick(row, ["tiempoBruto", "TiempoBruto"]));
      const activoNyxSeg = this.sumFromRows(source, (row) => pick(row, ["activoNyxSeg", "ActivoNyxSeg"]));
      const operacionesCant = this.sumFromRows(source, (row) => pick(row, ["operacionesCant", "OperacionesCant"]));
      const reportes = this.sumFromRows(source, (row) => pick(row, ["reportes", "Reportes"]));
      const tiempoParosSeg = this.sumFromRows(source, (row) => pick(row, ["tiempoParosSeg", "TiempoParosSeg"]));
      const tiempoParoProgramadoSeg = this.sumFromRows(source, (row) =>
        pick(row, ["tiempoParoProgramadoSeg", "TiempoParoProgramadoSeg"])
      );
      const piezasTeoricas = this.sumFromRows(source, (row) => pick(row, ["piezasTeoricas", "PiezasTeoricas"]));
      const tiempoParos = this.sumFromRows(source, (row) => pick(row, ["tiempoParos", "TiempoParos"]));
      const tiempoMuerto = this.sumFromRows(source, (row) => pick(row, ["tiempoMuerto", "TiempoMuerto"]));
      const tiempoNeto = this.sumFromRows(source, (row) => pick(row, ["tiempoNeto", "TiempoNeto"]));
      const ineficiencia =
        oee != null
          ? 100 - oee
          : this.avgFromRows(source, (row) => pick(row, ["ineficiencia", "Ineficiencia"]));

      return {
        ...first,
        turno: "Dia",
        inicio,
        fin,
        totalPiezas,
        tiempoCiclo,
        operacionesCant,
        piezasOk,
        reportes,
        piezasNoOk,
        tiempoOperacionSeg,
        segundosDebieronTrabajar,
        tiempoParosSeg,
        tiempoParoProgramadoSeg,
        tiempoParoNoProgramadoSeg,
        detallessParos,
        articulos: [],
        piezasTeoricas,
        piezasEsperadasHoraNYX: piezasXHoraTeoricas,
        tiempoBruto,
        oee,
        ineficiencia,
        tiempoParos,
        tiempoMuerto,
        tiempoNeto,
        scrap: null,
        calidad,
        activoNyxSeg,
        disponibilidadNyx: disponibilidad,
        disponibilidad,
        eficiencia,
        piezasXHoraTeoricas,
        piezasXHoraReport
      };
    },
    buildGroupedByShift(rows) {
      const groups = new Map();
      rows.forEach((row, index) => {
        const turnoLabel = row.turno != null ? String(row.turno) : "SHIFT";
        const shiftId = this.extractShiftId(row);
        const key = this.isDaySummaryTurno(turnoLabel)
          ? "DAY"
          : shiftId != null
            ? `SHIFT_ID_${shiftId}`
            : `SHIFT_NAME_${turnoLabel}`;

        if (!groups.has(key)) {
          groups.set(key, {
            rows: [],
            firstIndex: index,
            shiftId: null,
            turnoLabel
          });
        }

        const group = groups.get(key);
        group.rows.push(row);

        if (group.shiftId == null && shiftId != null) group.shiftId = shiftId;
      });

      return Array.from(groups.entries())
        .sort(([, groupA], [, groupB]) =>
          this.compareShiftGroups(groupA, groupB)
        )
        .map(([groupKey, groupData]) => {
          const turno = groupData.turnoLabel || "SHIFT";
          const displayRows = this.decorateRowsByMachine(groupData.rows);
          return {
            key: groupKey,
            turno,
            shiftLabel: this.formatShiftLabel(turno),
            rows: displayRows,
            summary: this.buildSummary(displayRows)
          };
        });
    },
    extractShiftId(row) {
      const raw = row?.idTurno ?? row?.IdTurno ?? row?.turnoId ?? row?.TurnoId;
      const num = Number(raw);
      return Number.isFinite(num) ? num : null;
    },
    compareShiftGroups(groupA, groupB) {
      const aIsDay = this.isDaySummaryTurno(groupA.turnoLabel);
      const bIsDay = this.isDaySummaryTurno(groupB.turnoLabel);
      if (aIsDay && bIsDay) return 0;
      if (aIsDay) return 1;
      if (bIsDay) return -1;

      if (groupA.shiftId != null && groupB.shiftId != null && groupA.shiftId !== groupB.shiftId) {
        return groupA.shiftId - groupB.shiftId;
      }
      if (groupA.shiftId != null && groupB.shiftId == null) return -1;
      if (groupA.shiftId == null && groupB.shiftId != null) return 1;

      return groupA.firstIndex - groupB.firstIndex;
    },
    normalizeWeekItems(dataSemanas) {
      if (!Array.isArray(dataSemanas)) return [];
      return dataSemanas.flatMap((week) => (Array.isArray(week.maquinas) ? week.maquinas : []));
    },
    flattenItems(items) {
      const rows = [];
      (items || []).forEach((item) => {
        const articulos = Array.isArray(item.articulos) ? item.articulos : [];
        if (articulos.length) {
          articulos.forEach((articulo) => {
            rows.push({
              ...item,
              ...articulo,
              articulo: articulo.articulo ?? articulo.Articulo ?? "",
              __rowType: "articulo",
              __parent: item
            });
          });
        } else {
          rows.push({
            ...item,
            articulo: "",
            __rowType: "maquina",
            __parent: null
          });
        }
      });
      return rows;
    },
    getMachineKey(row) {
      return String(row.maquinaIns ?? row.MaquinaIns ?? row.maquina ?? row.Maquina ?? "SIN MAQUINA");
    },
    getDayLabel(row) {
      const raw = String(row?.diaSemanaFecha ?? row?.DiaSemanaFecha ?? "").trim();
      if (raw) return raw;
      const fecha = this.extractDateString(row);
      if (fecha) {
        const d = new Date(`${fecha}T00:00:00`);
        if (!Number.isNaN(d.getTime())) {
          return d.toLocaleDateString("es-MX", { weekday: "long" });
        }
      }
      return "DÃ­a";
    },
    getDayKey(row, label, index) {
      const raw = String(row?.diaSemanaFecha ?? row?.DiaSemanaFecha ?? label ?? `DIA-${index}`).trim();
      return raw.toLowerCase();
    },
    getSortableDate(row) {
      const raw = this.extractDateString(row);
      if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) return raw;
      return "";
    },
    normalizeDayLabel(label) {
      return String(label || "")
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
    },
    dayOrder(label) {
      const key = this.normalizeDayLabel(label);
      const order = {
        lunes: 1,
        martes: 2,
        miercoles: 3,
        jueves: 4,
        viernes: 5,
        sabado: 6,
        domingo: 7,
      };
      return order[key] || 99;
    },
    decorateRowsByMachine(rows) {
      const orderedRows = this.orderRowsByMachine(rows);
      const counts = new Map();
      orderedRows.forEach((row) => {
        const key = this.getMachineKey(row);
        counts.set(key, (counts.get(key) || 0) + 1);
      });

      const seen = new Set();
      return orderedRows.map((row) => {
        const key = this.getMachineKey(row);
        if (seen.has(key)) {
          return { ...row, __machineRowspan: 0 };
        }
        seen.add(key);
        return { ...row, __machineRowspan: counts.get(key) || 1 };
      });
    },
    orderRowsByMachine(rows) {
      const buckets = new Map();
      const order = [];
      rows.forEach((row) => {
        const key = this.getMachineKey(row);
        if (!buckets.has(key)) {
          buckets.set(key, []);
          order.push(key);
        }
        buckets.get(key).push(row);
      });
      return order.flatMap((key) => buckets.get(key));
    },
    getShiftDateLabel(rows) {
      const dates = rows
        .map((row) => this.extractDateString(row))
        .filter(Boolean)
        .map((dateStr) => this.normalizeDateString(dateStr))
        .filter(Boolean)
        .sort();

      if (!dates.length) return "";
      const first = dates[0];
      const last = dates[dates.length - 1];
      if (first === last) {
        return this.formatDateLabel(first);
      }
      return `${this.formatDateLabel(first)} - ${this.formatDateLabel(last)}`;
    },
    extractDateString(row) {
      if (row.fecha) return String(row.fecha);
      if (row.inicio) return String(row.inicio);
      return "";
    },
    normalizeDateString(value) {
      const raw = String(value || "").trim();
      if (!raw) return "";
      const datePart = raw.split("T")[0].split(" ")[0];
      return datePart || raw;
    },
    formatDateLabel(dateStr) {
      const clean = String(dateStr || "").trim();
      if (/^\d{4}-\d{2}-\d{2}$/.test(clean)) {
        const [yyyy, mm, dd] = clean.split("-");
        return `${dd}/${mm}/${yyyy}`;
      }
      return clean;
    },
    formatShiftLabel(turno) {
      const raw = String(turno || "").trim();
      if (!raw) return "SHIFT";
      return raw;
    },
    buildSummary(rows) {
      const summary = {};
      const firstTextKey = this.columns.find((col) => col.type === "text")?.key;
      this.columns.forEach((col) => {
        if (col.type === "text") {
          summary[col.key] = col.key === firstTextKey ? "SHIFT RESULT" : "";
          return;
        }

        const values = rows
          .map((row) => this.getValue(row, col))
          .map((value) => Number(value))
          .filter((value) => Number.isFinite(value));

        if (!values.length) {
          summary[col.key] = null;
          return;
        }

        const aggregate = col.aggregate || "sum";
        if (aggregate === "avg") {
          const total = values.reduce((sum, val) => sum + val, 0);
          summary[col.key] = total / values.length;
          return;
        }

        summary[col.key] = values.reduce((sum, val) => sum + val, 0);
      });

      return summary;
    },
    toNumber(value) {
      const num = Number(value);
      return Number.isFinite(num) ? num : null;
    },
    getValue(row, col) {
      if (col.key === "articulo") {
        return row.articulo ?? row.Articulo ?? "";
      }
      if (col.key === "scrap") {
        return this.getPiezasNoOk(row);
      }
      if (col.key === "tiempoOperacionSeg") {
        return row.tiempoOperacionSeg ?? row.TiempoOperacionSeg ?? row.activoNyxSeg ?? row.ActivoNyxSeg;
      }
      if (col.key === "segundosDebieronTrabajar") {
        return row.segundosDebieronTrabajar ?? row.segundosDebieronTrabajar;
      }
      if (col.key === "tiempoParoNoProgramadoSeg") {
        return (
          row.tiempoParoNoProgramadoSeg ??
          row.TiempoParoNoProgramadoSeg ??
          row.tiempoParosSeg ??
          row.TiempoParosSeg
        );
      }
      if (col.key === "piezasXHoraTeoricas") {
        return (
          row.piezasEsperadasHoraNYX ??
          row.PiezasEsperadasHoraNYX ??
          row.piezasXHoraTeoricas ??
          row.PiezasXHoraTeoricas
        );
      }
      if (col.key === "piezasXHoraReport") {
        return (
          row.piezasXHoraReport ??
          row.PiezasXHoraReport ??
          this.calcularPiezasHoraActual(row)
        );
      }
      if (col.key === "disponibilidad") {
        return (
          row.disponibilidadNyx ??
          row.DisponibilidadNyx ??
          row.disponibilidad ??
          row.Disponibilidad
        );
      }
      if (col.key === "eficiencia") {
        return row.eficiencia ?? row.Eficiencia ?? row.eficienciaNyx ?? row.EficienciaNyx;
      }
      if (col.key === "oee") {
        return row.oee ?? row.Oee;
      }
      return row[col.key];
    },
    getPiezasNoOk(row) {
      const direct = this.toNumber(
        row?.piezasNoOk ??
        row?.PiezasNoOk ??
        row?.piezasNOk ??
        row?.PiezasNOk
      );
      if (direct != null) return direct;

      const total = this.toNumber(row?.totalPiezas ?? row?.TotalPiezas);
      const ok = this.toNumber(row?.piezasOk ?? row?.PiezasOk);
      if (total != null && ok != null) return Math.max(0, total - ok);

      const scrap = this.toNumber(row?.scrap ?? row?.Scrap);
      if (scrap == null) return null;
      if (total != null && scrap >= 0 && scrap <= 1) return Math.max(0, scrap * total);
      return scrap;
    },
    calcularPiezasHoraActual(row) {
      const total = this.toNumber(row.totalPiezas ?? row.TotalPiezas ?? row.piezasOk ?? row.PiezasOk);
      const tiempoSeg = this.toNumber(
        row.tiempoOperacionSeg ??
        row.TiempoOperacionSeg ??
        row.activoNyxSeg ??
        row.ActivoNyxSeg
      );
      if (total == null || !tiempoSeg || tiempoSeg <= 0) return null;
      return total / (tiempoSeg / 3600);
    },
    formatCell(row, col) {
      const value = this.getValue(row, col);

      if (col.type === "text") {
        return value != null ? String(value) : "";
      }

      if (col.type === "percent") {
        return this.formatPercent(value, col.decimals);
      }

      if (col.type === "hours") {
        return this.formatHours(value, col.decimals, col.fromSeconds);
      }

      return this.formatNumber(value, col.decimals);
    },
    formatNumber(value, decimals = 0) {
      const num = Number(value);
      if (!Number.isFinite(num)) return "";
      return num.toFixed(decimals);
    },
    formatHours(value, decimals = 2, fromSeconds = false) {
      const num = Number(value);
      if (!Number.isFinite(num)) return "";
      const hours = fromSeconds ? num / 3600 : num;
      return hours.toFixed(decimals);
    },
    formatPercent(value, decimals = 2) {
      const num = Number(value);
      if (!Number.isFinite(num)) return "----";
      return `${num.toFixed(decimals)}%`;
    },
    buildNyxParams() {
      const semana = this.selectedWeekInfo;
      if (!semana?.desde || !semana?.hasta) return null;
      const idsTurnos = (this.turnosSel || []).filter((val) => val != null && val !== "");
      const idsMaquinas = (this.instanciasSel || []).filter((val) => val != null && val !== "");
      const params = new URLSearchParams();
      params.append("desde", semana.desde);
      params.append("hasta", semana.hasta);
      idsTurnos.forEach((id) => {
        params.append("idsTurnos", id);
      });
      idsMaquinas.forEach((id) => {
        params.append("idsMaquinasInstancias", id);
      });
      return params;
    },
    obtenerDatos() {
      const params = this.buildNyxParams();
      if (!params) return;

      this.loading = true;
      axios
        .get(`OEEV2/OEEDetalladoNyxV2?${params.toString()}`)
        .then(res => {
          const payload = res?.data || {};
          const individualItems = Array.isArray(payload.dataIndividual) ? payload.dataIndividual : [];
          this.items = this.normalizeIndividualItems(individualItems);
          this.weekItems = this.normalizeWeekItems(payload.dataSemanas);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    descargarExcel() {
      const params = this.buildNyxParams();
      if (!params) return;
      this.loading = true;
      const semana = this.selectedWeekInfo;
      const desde = semana?.desde || "desde";
      const hasta = semana?.hasta || "hasta";
      axios
        .get(`/OEEV2/ExcelDetalladoNyxV2?${params.toString()}`, { responseType: "blob" })
        .then((response) => {
          const blob = new Blob(
            [response.data],
            { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }
          );
          const link = document.createElement("a");
          const blobURL = URL.createObjectURL(blob);
          link.download = `oee-detallado-nyx-v2-${desde}-${hasta}.xlsx`;
          link.href = blobURL;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(blobURL);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    headerCellClass(col) {
      return [
        "oee-nyx__header-cell",
        col.shaded ? "oee-nyx__header-cell--shaded" : "",
        col.align ? `oee-nyx__cell--${col.align}` : ""
      ];
    },
    cellClass(col) {
      return [
        "oee-nyx__cell",
        col.shaded ? "oee-nyx__cell--shaded" : "",
        col.align ? `oee-nyx__cell--${col.align}` : ""
      ];
    },
    valueClass(value) {
      return {
        "oee-nyx__value": true,
        "oee-nyx__value--error": value === "----"
      };
    }
  },
  mounted() {
    this.init();
    this.initYears();
    this.obtenerDatos();
  },
};
</script>

<style scoped>
.oee-nyx {
  font-family: "Trebuchet MS", "Segoe UI", Tahoma, Arial, sans-serif;
}

.oee-nyx__filters {
  margin-bottom: 12px;
}

.oee-nyx__table-wrapper {
  overflow-x: auto;
  border: 2px solid #000;
  background: #fff;
}

.oee-nyx__table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.oee-nyx__header-row {
  background: #ffe600;
}

.oee-nyx__header-cell {
  border: 1px solid #000;
  padding: 6px 8px;
  font-size: 12px;
  font-weight: 700;
  color: #000;
}

.oee-nyx__header-cell--shaded {
  background: #d9dde5;
}

.oee-nyx__cell {
  border: 1px solid #b8b8b8;
  padding: 4px 8px;
  font-size: 12px;
  color: #111;
  background: #fff;
}

.oee-nyx__cell--shaded {
  background: #dfe3ea;
}

.oee-nyx__cell--right {
  text-align: right;
}

.oee-nyx__cell--left {
  text-align: left;
}

.oee-nyx__cell--center {
  text-align: center;
}

.oee-nyx__summary-row .oee-nyx__cell {
  background: #bff3ff;
  font-weight: 700;
  border-top: 2px solid #000;
}

.oee-nyx__spacer td {
  height: 14px;
  border: none;
  background: #fff;
}

.oee-nyx__value {
  position: relative;
  display: inline-block;
  width: 100%;
  padding-right: 6px;
  box-sizing: border-box;
}

.oee-nyx__value--error::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: 0;
  height: 0;
  border-top: 7px solid #d32f2f;
  border-left: 7px solid transparent;
}

.oee-nyx__empty {
  text-align: center;
  padding: 24px;
  color: #666;
  font-size: 13px;
}
</style>
